(function() {

    'use strict';


    var SWF = SAPO.Utility.SWF;



    function FlashBuilder(item, parentEl) {
        SWF.embed({
            swf:       item.src,            // SWF file to load
            dims:      item.dims,                   // dimensions in pixels
            container: parentEl,            // container element
            params: { // params
                 allowfullscreen:   true     // if trueish, allowfullscreen param is set to true
                ,allowscriptaccess: 'always' // allowscriptaccess param
                ,wmode:             'transparent' // wmode param: opaque | transparent | window
                 //bgcolor:           '#FF0000',     // bgcolor param
                 //quality:           'high'         // quality param
            },
            flashvars: {}, // flashVars
            insteadOf: false // if true, repaces container, otherwise appends container
        });
    }



    function FlashHdlr(item) { // isLinear must be true here...
        if (
            item.nodeName !== 'StaticResource' ||
            item.type     !== 'application/x-shockwave-flash'
        ) { return; }

        return {
            mimeType:    item.type,
            description: 'non-linear flash resource',
            item:        item,
            builder:     FlashBuilder
        };
    }



    SAPO.Project.Video.VAST.handlers.Flash = FlashHdlr;

})();
